/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */

import {combineReducers} from 'redux';
import applications from './applications';
import institutions from './institutions';
import {reducer as domainapps} from './DomainApplicationView/state';

/**
 * Reducer that manages the 'entities' branch of the application state.
 *
 * @type {Reducer<any>}
 */
const entitiesReducer = combineReducers({
  'institutions': institutions.reducer,
  'applications': applications.reducer
});

/**
 * A no-op reducer that never modifies application state. The intent of this is to create empty branches of state
 * that are populated server-side. Not having a reducer for such state will cause Redux to fail when creating the
 * initial state.
 *
 * @param state
 * @param action
 * @return {*}
 */
const noOpReducer = (state = null, action) => {
  return state;
};

const rootReducer = combineReducers({
  'entities': entitiesReducer,
  'user': noOpReducer,
  'custSandboxEnv': noOpReducer,
  'ui': combineReducers({
    'domainapp': domainapps,
  }),
  'errors': noOpReducer
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/rootReducer.js